import FieldPasteFile from './FieldPasteFile';

export default FieldPasteFile;
